import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { App } from "./App";
import { DataProvider, readSeed } from "./lib/routeData";
import "./styles/global.css";
import "./styles/components.css";
import "./styles/utilities.css";

const seed = readSeed();
const container = document.getElementById("root")!;

const tree = (
  <StrictMode>
    <DataProvider seed={seed}>
      <App />
    </DataProvider>
  </StrictMode>
);

// A server-rendered document has markup to adopt; a cold SPA shell does not.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
